export const ScrollTo = (props) => {
  const reference = document.getElementById(props) as HTMLElement;
  reference.scrollIntoView({ behavior: "smooth" });
};
